const isDev = process.env.REACT_APP_DEV === "true";

export default {
    apiAddress: isDev ? 'http://192.168.0.29:5000/' : `${process.env.REACT_APP_BACKEND_REALM}/`
};
